export const IS_MOCK = process.env.REACT_APP_MOCK_MODE === "true";

export const MOCK_USER_DATA = {
  token: "mock-test-token-12345",
  operatorId: "testOperator",
  userName: "TestUser",
  uid: "test-uid-001",
  balance: 50000,
  exposure: 0,
  homeUrl: "http://localhost:3000",
};

const generateMarketId = (prefix) => {
  const id = Math.floor(Math.random() * 9000000 + 1000000);
  return `${prefix}.${id}`;
};



const makeOddDetails = (runners) =>
  runners.map((r, i) => ({
    runnerName: r.name,
    selectionId: r.selectionId || 100 + i,
    back1: r.back1 || (Math.random() * 3 + 1.1).toFixed(2),
    lay1: r.lay1 || 0,
    status: "ACTIVE",
  }));

export const MOCK_DRAGON_TIGER_20 = {
  marketId: generateMarketId("DT20"),
  autoTime: 25,
  cards: [["DSA", "H2"]],
  oddDetailsDTOS: makeOddDetails([
    { name: "Dragon", back1: "1.98", selectionId: 101 },
    { name: "Tiger", back1: "1.98", selectionId: 102 },
    { name: "Tie", back1: "8.00", selectionId: 103 },
    { name: "Pair", back1: "11.00", selectionId: 104 },
    { name: "Dragon Even", back1: "2.10", selectionId: 105 },
    { name: "Dragon Odd", back1: "1.80", selectionId: 106 },
    { name: "Tiger Even", back1: "2.10", selectionId: 107 },
    { name: "Tiger Odd", back1: "1.80", selectionId: 108 },
    { name: "Dragon Red", back1: "2.10", selectionId: 109 },
    { name: "Dragon Black", back1: "1.80", selectionId: 110 },
    { name: "Tiger Red", back1: "2.10", selectionId: 111 },
    { name: "Tiger Black", back1: "1.80", selectionId: 112 },
    { name: "Dragon Card 1", back1: "12.00", selectionId: 201 },
    { name: "Dragon Card 2", back1: "12.00", selectionId: 202 },
    { name: "Dragon Card 3", back1: "12.00", selectionId: 203 },
    { name: "Dragon Card 4", back1: "12.00", selectionId: 204 },
    { name: "Dragon Card 5", back1: "12.00", selectionId: 205 },
    { name: "Dragon Card 6", back1: "12.00", selectionId: 206 },
    { name: "Dragon Card 7", back1: "12.00", selectionId: 207 },
    { name: "Dragon Card 8", back1: "12.00", selectionId: 208 },
    { name: "Dragon Card 9", back1: "12.00", selectionId: 209 },
    { name: "Dragon Card 10", back1: "12.00", selectionId: 210 },
    { name: "Dragon Card J", back1: "12.00", selectionId: 211 },
    { name: "Dragon Card Q", back1: "12.00", selectionId: 212 },
    { name: "Dragon Card K", back1: "12.00", selectionId: 213 },
    { name: "Tiger Card 1", back1: "12.00", selectionId: 301 },
    { name: "Tiger Card 2", back1: "12.00", selectionId: 302 },
    { name: "Tiger Card 3", back1: "12.00", selectionId: 303 },
    { name: "Tiger Card 4", back1: "12.00", selectionId: 304 },
    { name: "Tiger Card 5", back1: "12.00", selectionId: 305 },
    { name: "Tiger Card 6", back1: "12.00", selectionId: 306 },
    { name: "Tiger Card 7", back1: "12.00", selectionId: 307 },
    { name: "Tiger Card 8", back1: "12.00", selectionId: 308 },
    { name: "Tiger Card 9", back1: "12.00", selectionId: 309 },
    { name: "Tiger Card 10", back1: "12.00", selectionId: 310 },
    { name: "Tiger Card J", back1: "12.00", selectionId: 311 },
    { name: "Tiger Card Q", back1: "12.00", selectionId: 312 },
    { name: "Tiger Card K", back1: "12.00", selectionId: 313 },
  ]),
};

export const MOCK_TEEN_PATTI_20 = {
  marketId: generateMarketId("TP20"),
  autoTime: 20,
  cards: [
    ["SA", "H2", "D5"],
    ["CK", "HQ", "S3"],
  ],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player A", back1: "1.98", selectionId: 101 },
    { name: "Player B", back1: "1.98", selectionId: 102 },
  ]),
};

export const MOCK_LUCKY7 = {
  marketId: generateMarketId("L7"),
  autoTime: 20,
  cards: [["H7"]],
  oddDetailsDTOS: makeOddDetails([
    { name: "Low Card", back1: "2.10", selectionId: 101 },
    { name: "High Card", back1: "2.10", selectionId: 102 },
    { name: "Low Card (Black)", back1: "2.10", selectionId: 103 },
    { name: "Low Card (Red)", back1: "2.10", selectionId: 104 },
    { name: "High Card (Black)", back1: "2.10", selectionId: 105 },
    { name: "High Card (Red)", back1: "2.10", selectionId: 106 },
    { name: "Card A", back1: "12.00", selectionId: 201 },
    { name: "Card 2", back1: "12.00", selectionId: 202 },
    { name: "Card 3", back1: "12.00", selectionId: 203 },
    { name: "Card 4", back1: "12.00", selectionId: 204 },
    { name: "Card 5", back1: "12.00", selectionId: 205 },
    { name: "Card 6", back1: "12.00", selectionId: 206 },
    { name: "Card 7", back1: "12.00", selectionId: 207 },
    { name: "Card 8", back1: "12.00", selectionId: 208 },
    { name: "Card 9", back1: "12.00", selectionId: 209 },
    { name: "Card 10", back1: "12.00", selectionId: 210 },
    { name: "Card J", back1: "12.00", selectionId: 211 },
    { name: "Card Q", back1: "12.00", selectionId: 212 },
    { name: "Card K", back1: "12.00", selectionId: 213 },
  ]),
};

export const MOCK_ANDAR_BAHAR = {
  marketId: generateMarketId("AB"),
  autoTime: 18,
  cards: [["HK"]],
  oddDetailsDTOS: makeOddDetails([
    { name: "Andar", back1: "1.98", selectionId: 101 },
    { name: "Bahar", back1: "1.98", selectionId: 102 },
  ]),
};

export const MOCK_POKER_20 = {
  marketId: generateMarketId("PK20"),
  autoTime: 22,
  cards: [
    ["SA", "H10", "DQ", "C5", "S8"],
    ["HA", "D10", "CQ", "S5", "H8"],
    ["D3", "C7", "H9", "S2", "D6"],
  ],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player A", back1: "1.98", selectionId: 101 },
    { name: "Player B", back1: "1.98", selectionId: 102 },
  ]),
};

export const MOCK_CARD32 = {
  marketId: generateMarketId("C32"),
  autoTime: 20,
  cards: [
    ["SA", "H2"],
    ["DK", "CQ"],
    ["H5", "S9"],
    ["D3", "C7"],
  ],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player 8", back1: "3.80", selectionId: 101 },
    { name: "Player 9", back1: "4.20", selectionId: 102 },
    { name: "Player 10", back1: "3.50", selectionId: 103 },
    { name: "Player 11", back1: "5.00", selectionId: 104 },
  ]),
};

export const MOCK_BACCARAT = {
  marketId: generateMarketId("BAC"),
  autoTime: 20,
  cards: [
    ["SA", "H5"],
    ["DK", "C8"],
  ],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player", back1: "2.00", selectionId: 101 },
    { name: "Banker", back1: "1.98", selectionId: 102 },
    { name: "Tie", back1: "8.00", selectionId: 103 },
  ]),
};

export const MOCK_RACE20 = {
  marketId: generateMarketId("R20"),
  autoTime: 20,
  cards: [["SK"], ["H3"], ["D8"], ["C6"]],
  oddDetailsDTOS: makeOddDetails([
    { name: "Spade", back1: "3.80", selectionId: 101 },
    { name: "Heart", back1: "4.20", selectionId: 102 },
    { name: "Diamond", back1: "3.50", selectionId: 103 },
    { name: "Club", back1: "5.00", selectionId: 104 },
  ]),
};

export const MOCK_CASINO_QUEEN = {
  marketId: generateMarketId("CQ"),
  autoTime: 20,
  cards: [["HQ"]],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player A", back1: "1.98", selectionId: 101 },
    { name: "Player B", back1: "1.98", selectionId: 102 },
  ]),
};

export const MOCK_DTL = {
  marketId: generateMarketId("DTL"),
  autoTime: 20,
  cards: [["HA", "D5", "CK"]],
  oddDetailsDTOS: makeOddDetails([
    { name: "Dragon", back1: "2.90", selectionId: 101 },
    { name: "Tiger", back1: "2.90", selectionId: 102 },
    { name: "Lion", back1: "2.90", selectionId: 103 },
  ]),
};

export const MOCK_AAA = {
  marketId: generateMarketId("AAA"),
  autoTime: 20,
  cards: [["HA"], ["DK"], ["C5"]],
  oddDetailsDTOS: makeOddDetails([
    { name: "Amar", back1: "2.90", selectionId: 101 },
    { name: "Akbar", back1: "2.90", selectionId: 102 },
    { name: "Anthony", back1: "2.90", selectionId: 103 },
  ]),
};

export const MOCK_WORLI = {
  marketId: generateMarketId("WRL"),
  autoTime: 20,
  cards: [],
  oddDetailsDTOS: makeOddDetails([
    { name: "0", back1: "9.50", selectionId: 100 },
    { name: "1", back1: "9.50", selectionId: 101 },
    { name: "2", back1: "9.50", selectionId: 102 },
    { name: "3", back1: "9.50", selectionId: 103 },
    { name: "4", back1: "9.50", selectionId: 104 },
    { name: "5", back1: "9.50", selectionId: 105 },
    { name: "6", back1: "9.50", selectionId: 106 },
    { name: "7", back1: "9.50", selectionId: 107 },
    { name: "8", back1: "9.50", selectionId: 108 },
    { name: "9", back1: "9.50", selectionId: 109 },
  ]),
};

export const MOCK_SUPER_OVER = {
  marketId: generateMarketId("SO"),
  autoTime: 20,
  cards: [],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player A", back1: "1.98", selectionId: 101 },
    { name: "Player B", back1: "1.98", selectionId: 102 },
  ]),
};

export const MOCK_CRICKET_MATCH = {
  marketId: generateMarketId("CM20"),
  autoTime: 20,
  cards: [],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player A", back1: "1.98", selectionId: 101 },
    { name: "Player B", back1: "1.98", selectionId: 102 },
  ]),
};

export const MOCK_CASINO_WAR = {
  marketId: generateMarketId("CW"),
  autoTime: 20,
  cards: ["HA", "DK", "S3", "C7", "H5", "D9", ["S2"]],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player A", back1: "1.98", selectionId: 101 },
    { name: "Player B", back1: "1.98", selectionId: 102 },
    { name: "Tie", back1: "10.00", selectionId: 103 },
  ]),
};

export const MOCK_CASINO_METER = {
  marketId: generateMarketId("CMT"),
  autoTime: 20,
  cards: [
    ["HA", "S3", "D5"],
    ["HK", "SQ", "D10"],
  ],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player A", back1: "1.98", selectionId: 101 },
    { name: "Player B", back1: "1.98", selectionId: 102 },
  ]),
};

export const MOCK_BOLLYWOOD = {
  marketId: generateMarketId("BW"),
  autoTime: 20,
  cards: [],
  oddDetailsDTOS: makeOddDetails([
    { name: "Player A", back1: "1.98", selectionId: 101 },
    { name: "Player B", back1: "1.98", selectionId: 102 },
    { name: "Player C", back1: "1.98", selectionId: 103 },
  ]),
};

// Map game keys to mock data
export const MOCK_GAME_DATA = {
  dragonTiger20: MOCK_DRAGON_TIGER_20,
  dragonTiger202: { ...MOCK_DRAGON_TIGER_20, marketId: generateMarketId("DT202") },
  dragonTigerOneDay: { ...MOCK_DRAGON_TIGER_20, marketId: generateMarketId("DT1D") },
  dragonTigerLion: MOCK_DTL,
  teenPatti20: MOCK_TEEN_PATTI_20,
  teen: { ...MOCK_TEEN_PATTI_20, marketId: generateMarketId("T1D") },
  teen8: {
    ...MOCK_TEEN_PATTI_20,
    marketId: generateMarketId("T8"),
    cards: [
      ["SA", "H2", "D5"],
      ["CK", "HQ", "S3"],
    ],
  },
  teen9: { ...MOCK_TEEN_PATTI_20, marketId: generateMarketId("T9") },
  lucky7: MOCK_LUCKY7,
  lucky7eu: { ...MOCK_LUCKY7, marketId: generateMarketId("L7B") },
  andarBahar20: MOCK_ANDAR_BAHAR,
  abj: { ...MOCK_ANDAR_BAHAR, marketId: generateMarketId("AB2") },
  poker20: MOCK_POKER_20,
  poker9: { ...MOCK_POKER_20, marketId: generateMarketId("PK6") },
  card32: MOCK_CARD32,
  card32eu: { ...MOCK_CARD32, marketId: generateMarketId("C32B") },
  baccarat: MOCK_BACCARAT,
  baccarat2: { ...MOCK_BACCARAT, marketId: generateMarketId("BAC2") },
  race20: MOCK_RACE20,
  casinoQueen: MOCK_CASINO_QUEEN,
  casinoWar: MOCK_CASINO_WAR,
  casinoMeter: MOCK_CASINO_METER,
  aaa: MOCK_AAA,
  bollywoodTable: MOCK_BOLLYWOOD,
  worli: MOCK_WORLI,
  worli2: { ...MOCK_WORLI, marketId: generateMarketId("WRL2") },
  superOver: MOCK_SUPER_OVER,
  cmatch20: MOCK_CRICKET_MATCH,
  cricketV3: { ...MOCK_CRICKET_MATCH, marketId: generateMarketId("CV3") },
};

// Map game keys to their Redux action types
const GAME_ACTION_MAP = {
  dragonTiger20: "gameData/setDragonTiger20Odds",
  dragonTiger202: "gameData/setDragonTiger202Odds",
  dragonTigerOneDay: "gameData/setDragonTigerOneDayOdds",
  dragonTigerLion: "gameData/setDragonTigerLionOdds",
  teenPatti20: "gameData/setTeenPatti20Odds",
  teen: "gameData/setTeenOdds",
  teen8: "gameData/setTeen8Odds",
  teen9: "gameData/setTeen9Odds",
  lucky7: "gameData/setLucky7Odds",
  lucky7eu: "gameData/setLucky7euOdds",
  andarBahar20: "gameData/setAndarBahar20Odds",
  abj: "gameData/setAbjOdds",
  poker20: "gameData/setPoker20Odds",
  poker9: "gameData/setPoker9Odds",
  card32: "gameData/setCard32Odds",
  card32eu: "gameData/setCard32euOdds",
  baccarat: "gameData/setBaccaratOdds",
  baccarat2: "gameData/setBaccarat20Odds",
  race20: "gameData/setRace20Odds",
  casinoQueen: "gameData/setCasinoQueenOdds",
  casinoWar: "gameData/setCasinoWarOdds",
  casinoMeter: "gameData/setCasinoMeterOdds",
  aaa: "gameData/setAaaOdds",
  bollywoodTable: "gameData/setBollywoodTableOdds",
  worli: "gameData/setWorliOdds",
  worli2: "gameData/setWorli2Odds",
  superOver: "gameData/setSuperOverOdds",
  cmatch20: "gameData/setCmatch20Odds",
  cricketV3: "gameData/setCricketv3Odds",
};

// Simulate live updates by randomly changing autoTime countdown
export const createMockSocket = (id, dispatch, game) => {
  const mockData = MOCK_GAME_DATA[game];
  const actionType = GAME_ACTION_MAP[game];

  if (!mockData || !actionType) {
    dispatch({ type: "accountData/setLoading", payload: false });
    return;
  }

  dispatch({ type: "accountData/setLoading", payload: true });

  // Initial dispatch
  dispatch({ type: actionType, payload: { ...mockData } });
  dispatch({ type: "accountData/setLoading", payload: false });

  // Simulate countdown timer like the real WebSocket
  let autoTime = 30;
  const interval = setInterval(() => {
    autoTime--;
    if (autoTime <= 0) {
      autoTime = 30;
      // Simulate new round with new marketId
      mockData.marketId =
        mockData.marketId.split(".")[0] +
        "." +
        Math.floor(Math.random() * 9000000 + 1000000);
    }
    dispatch({
      type: actionType,
      payload: { ...mockData, autoTime },
    });
  }, 1000);

  // Return cleanup function (stored on window for cleanup)
  if (!window.__mockIntervals) window.__mockIntervals = [];
  window.__mockIntervals.push(interval);
};

// Mock API responses
export const MOCK_LAST_TEN_RESULTS = {
  data: {
    casinoMarketHistoryResponseDTOS: [
      { marketId: "DT20.1234567", mainWinner: "D" },
      { marketId: "DT20.1234568", mainWinner: "T" },
      { marketId: "DT20.1234569", mainWinner: "D" },
      { marketId: "DT20.1234570", mainWinner: "T" },
      { marketId: "DT20.1234571", mainWinner: "D" },
      { marketId: "DT20.1234572", mainWinner: "D" },
      { marketId: "DT20.1234573", mainWinner: "T" },
      { marketId: "DT20.1234574", mainWinner: "T" },
      { marketId: "DT20.1234575", mainWinner: "D" },
      { marketId: "DT20.1234576", mainWinner: "T" },
    ],
  },
};

export const MOCK_PL_EXPOSURE = {
  code: 200,
  response: [],
};

export const MOCK_MY_BETS = {
  code: 200,
  response: [],
};

export const MOCK_PLACE_BET_RESPONSE = {
  code: 200,
  response: "Bet placed successfully (Mock)",
};
